enum ItemType {
  GOOD = "good",
  SERVICE = "service",
  FOOD = "food",
  ELECTRONIC_SERVICE = "electronic-service",
  ELECTRONIC_PUBLICATION = "electronic-publication",
  LIVE_EVENT_CZ = "live-event-cz",
  LIVE_EVENT_SK = "live-event-sk",
  LIVE_EVENT_FOREIGN = "live-event-foreign",
  LIVE_EVENT = "live-event",
  DISCOUNT = "discount",
  EXCLUDING_VAT = "excluding_vat",
  SHIPPING = "shipping",
  PAYMENT_METHOD = "payment-method",
  PRINTED_PUBLICATION = "printed-publication",
  PRINTED_PERIOD_PUBLICATION = "printed-period-publication",
  ELECTRONIC_PERIOD_PUBLICATION = "electronic-period-publication",
}

export { ItemType };
